<template>
  <v-container fluid class="pa-0 ma-0">
    <!--    основной экран-->
    <MainDisplay/>
    <!--    давайте знакомиться-->
    <AboutMe/>
    <!--описание психотерапевта-->
    <Therapy/>
    <!--Ценности-->
    <Worth/>
<!--     с чем обращаются-->
    <Requests/>
<!--    с чем не работаю-->
    <NotWorkWith  />
  </v-container>
</template>

<script>
import MainDisplay from "@/components/home/MainDisplay";
import AboutMe from "@/components/home/AboutMe";
import Therapy from "@/components/home/Therapy";
import Worth from "@/components/home/Worth";
import Requests from "@/components/home/Requests";
import NotWorkWith from "@/components/home/NotWorkWith";

export default {
  name: 'Home',
  components: {
    NotWorkWith,
    Requests,
    Worth,
    Therapy,
    AboutMe,
    MainDisplay,
  },
  data() {
    return {}
  },
}
</script>


<style scoped>
.hidden-header {
  transform: translateY(-50px);
  opacity: 0.1;
}

.appear-header {
  transition: all 1.5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  opacity: 1;
}


.slide-fade-enter-active {
  transition: all 1.5s ease;
}

.slide-fade-leave-active {
  transition: all 1.5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active до версии 2.1.8 */
{
  transform: translateY(-50px);
  opacity: 0;
}

.image-main {
  background-image: url("../images/photo7.jpg");
  background-position: center center;
}

.image {
  /*background-image: url("../images/photo8.jpg");*/
  background-image: url("../images/photo4.jpg");
  /*  background-image: url("../images/photo3.jpg");*/
  /*  background-image: url("../images/photo2.jpg");*/
  background-position: center center;
  background-size: cover;
}


.button {
  text-decoration: none;
  font-size: 1.5em;
  color: #212121;
  transition: 0.2s linear;
  background: rgba(214, 214, 214, 0.68);
  padding: 0.5em 0.5em;
  border-radius: 10px;
}

.button:hover {
  color: #cccccc;
  background: rgba(214, 214, 214, 0.48);
}


.title {
  color: #5d4a3d;
}

.row {
  padding: 0;
  /*background-image: url("../images/55.jpg");*/
  /*background-repeat: repeat-x;*/
  /*background: #bbb9b4 ;*/
}

.v-application a {
  text-decoration: none;
}




/*list card*/


.v-card__title {
  word-break: normal;
}


.shadow-slider-right {
  box-shadow: -50vw 0 200px -20px rgba(0, 0, 0, 0.8) inset;
  width: 100vw;
}

.align-content-slider-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: none;
}

.card-decor {
  color: white;
  background: rgba(255, 255, 255, 0.09);
  margin-right: calc(20% - 8px);
}

.card-decor-mobile-right {
  width: calc(60% - 10px);
  margin-right: calc(28% - 8px);
}


.card-decor {
  color: white;
  background: rgba(255, 255, 255, 0.19) !important;
  margin-right: calc(13% - 8px);
}

.shadow-slider-left {
  box-shadow: 50vw 0 200px -20px rgba(0, 0, 0, 0.8) inset;
  width: 100vw;
}

.align-content-slider-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: none
}

.card-decor-left {
  color: white;
  background: rgba(255, 255, 255, 0.19) !important;
  margin-left: calc(20% - 8px);
}

.card-decor-mobile-left {
  margin-left: calc(28% - 8px);
  width: calc(70% - 10px);
}


/*left version*/


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}


.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}


</style>


